import { render } from "./TableControllerSetting.vue?vue&type=template&id=1acf190e&scoped=true"
import script from "./TableControllerSetting.vue?vue&type=script&lang=js"
export * from "./TableControllerSetting.vue?vue&type=script&lang=js"

import "./TableControllerSetting.vue?vue&type=style&index=0&id=1acf190e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1acf190e"]])

export default __exports__